import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { isStorageError, StorageError } from '../lib/errors';
import { get, post, remove as _remove } from '../lib/fetch';
import { resolveFetch } from '../lib/helpers';
var DEFAULT_SEARCH_OPTIONS = {
  limit: 100,
  offset: 0,
  sortBy: {
    column: 'name',
    order: 'asc'
  }
};
var DEFAULT_FILE_OPTIONS = {
  cacheControl: '3600',
  contentType: 'text/plain;charset=UTF-8',
  upsert: false
};
var StorageFileApi = /*#__PURE__*/function () {
  function StorageFileApi(url) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var bucketId = arguments.length > 2 ? arguments[2] : undefined;
    var fetch = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, StorageFileApi);
    this.url = url;
    this.headers = headers;
    this.bucketId = bucketId;
    this.fetch = resolveFetch(fetch);
  }
  /**
   * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
   *
   * @param method HTTP method.
   * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
   * @param fileBody The body of the file to be stored in the bucket.
   */
  _createClass(StorageFileApi, [{
    key: "uploadOrUpdate",
    value: function uploadOrUpdate(method, path, fileBody, fileOptions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var body, options, headers, cleanPath, _path, res, error;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              options = Object.assign(Object.assign({}, DEFAULT_FILE_OPTIONS), fileOptions);
              headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                'x-upsert': String(options.upsert)
              });
              if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                body = new FormData();
                body.append('cacheControl', options.cacheControl);
                body.append('', fileBody);
              } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                body = fileBody;
                body.append('cacheControl', options.cacheControl);
              } else {
                body = fileBody;
                headers['cache-control'] = "max-age=".concat(options.cacheControl);
                headers['content-type'] = options.contentType;
              }
              cleanPath = this._removeEmptyFolders(path);
              _path = this._getFinalPath(cleanPath);
              _context.next = 8;
              return this.fetch("".concat(this.url, "/object/").concat(_path), Object.assign({
                method: method,
                body: body,
                headers: headers
              }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                duplex: options.duplex
              } : {}));
            case 8:
              res = _context.sent;
              if (!res.ok) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", {
                data: {
                  path: cleanPath
                },
                error: null
              });
            case 13:
              _context.next = 15;
              return res.json();
            case 15:
              error = _context.sent;
              return _context.abrupt("return", {
                data: null,
                error: error
              });
            case 17:
              _context.next = 24;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](0);
              if (!isStorageError(_context.t0)) {
                _context.next = 23;
                break;
              }
              return _context.abrupt("return", {
                data: null,
                error: _context.t0
              });
            case 23:
              throw _context.t0;
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 19]]);
      }));
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */
  }, {
    key: "upload",
    value: function upload(path, fileBody, fileOptions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.uploadOrUpdate('POST', path, fileBody, fileOptions));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */
  }, {
    key: "uploadToSignedUrl",
    value: function uploadToSignedUrl(path, token, fileBody, fileOptions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var cleanPath, _path, url, body, options, headers, res, error;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              cleanPath = this._removeEmptyFolders(path);
              _path = this._getFinalPath(cleanPath);
              url = new URL(this.url + "/object/upload/sign/".concat(_path));
              url.searchParams.set('token', token);
              _context3.prev = 4;
              options = Object.assign({
                upsert: DEFAULT_FILE_OPTIONS.upsert
              }, fileOptions);
              headers = Object.assign(Object.assign({}, this.headers), {
                'x-upsert': String(options.upsert)
              });
              if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                body = new FormData();
                body.append('cacheControl', options.cacheControl);
                body.append('', fileBody);
              } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                body = fileBody;
                body.append('cacheControl', options.cacheControl);
              } else {
                body = fileBody;
                headers['cache-control'] = "max-age=".concat(options.cacheControl);
                headers['content-type'] = options.contentType;
              }
              _context3.next = 10;
              return this.fetch(url.toString(), {
                method: 'PUT',
                body: body,
                headers: headers
              });
            case 10:
              res = _context3.sent;
              if (!res.ok) {
                _context3.next = 15;
                break;
              }
              return _context3.abrupt("return", {
                data: {
                  path: cleanPath
                },
                error: null
              });
            case 15:
              _context3.next = 17;
              return res.json();
            case 17:
              error = _context3.sent;
              return _context3.abrupt("return", {
                data: null,
                error: error
              });
            case 19:
              _context3.next = 26;
              break;
            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](4);
              if (!isStorageError(_context3.t0)) {
                _context3.next = 25;
                break;
              }
              return _context3.abrupt("return", {
                data: null,
                error: _context3.t0
              });
            case 25:
              throw _context3.t0;
            case 26:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 21]]);
      }));
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for one minute.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     */
  }, {
    key: "createSignedUploadUrl",
    value: function createSignedUploadUrl(path) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _path, data, url, token;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _path = this._getFinalPath(path);
              _context4.next = 4;
              return post(this.fetch, "".concat(this.url, "/object/upload/sign/").concat(_path), {}, {
                headers: this.headers
              });
            case 4:
              data = _context4.sent;
              url = new URL(this.url + data.url);
              token = url.searchParams.get('token');
              if (token) {
                _context4.next = 9;
                break;
              }
              throw new StorageError('No token returned by API');
            case 9:
              return _context4.abrupt("return", {
                data: {
                  signedUrl: url.toString(),
                  path: path,
                  token: token
                },
                error: null
              });
            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](0);
              if (!isStorageError(_context4.t0)) {
                _context4.next = 16;
                break;
              }
              return _context4.abrupt("return", {
                data: null,
                error: _context4.t0
              });
            case 16:
              throw _context4.t0;
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 12]]);
      }));
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */
  }, {
    key: "update",
    value: function update(path, fileBody, fileOptions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.uploadOrUpdate('PUT', path, fileBody, fileOptions));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     */
  }, {
    key: "move",
    value: function move(fromPath, toPath) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return post(this.fetch, "".concat(this.url, "/object/move"), {
                bucketId: this.bucketId,
                sourceKey: fromPath,
                destinationKey: toPath
              }, {
                headers: this.headers
              });
            case 3:
              data = _context6.sent;
              return _context6.abrupt("return", {
                data: data,
                error: null
              });
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);
              if (!isStorageError(_context6.t0)) {
                _context6.next = 11;
                break;
              }
              return _context6.abrupt("return", {
                data: null,
                error: _context6.t0
              });
            case 11:
              throw _context6.t0;
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 7]]);
      }));
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     */
  }, {
    key: "copy",
    value: function copy(fromPath, toPath) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var data;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return post(this.fetch, "".concat(this.url, "/object/copy"), {
                bucketId: this.bucketId,
                sourceKey: fromPath,
                destinationKey: toPath
              }, {
                headers: this.headers
              });
            case 3:
              data = _context7.sent;
              return _context7.abrupt("return", {
                data: {
                  path: data.Key
                },
                error: null
              });
            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](0);
              if (!isStorageError(_context7.t0)) {
                _context7.next = 11;
                break;
              }
              return _context7.abrupt("return", {
                data: null,
                error: _context7.t0
              });
            case 11:
              throw _context7.t0;
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 7]]);
      }));
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */
  }, {
    key: "createSignedUrl",
    value: function createSignedUrl(path, expiresIn, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _path, data, downloadQueryParam, signedUrl;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _path = this._getFinalPath(path);
              _context8.next = 4;
              return post(this.fetch, "".concat(this.url, "/object/sign/").concat(_path), Object.assign({
                expiresIn: expiresIn
              }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                transform: options.transform
              } : {}), {
                headers: this.headers
              });
            case 4:
              data = _context8.sent;
              downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? "&download=".concat(options.download === true ? '' : options.download) : '';
              signedUrl = encodeURI("".concat(this.url).concat(data.signedURL).concat(downloadQueryParam));
              data = {
                signedUrl: signedUrl
              };
              return _context8.abrupt("return", {
                data: data,
                error: null
              });
            case 11:
              _context8.prev = 11;
              _context8.t0 = _context8["catch"](0);
              if (!isStorageError(_context8.t0)) {
                _context8.next = 15;
                break;
              }
              return _context8.abrupt("return", {
                data: null,
                error: _context8.t0
              });
            case 15:
              throw _context8.t0;
            case 16:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 11]]);
      }));
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */
  }, {
    key: "createSignedUrls",
    value: function createSignedUrls(paths, expiresIn, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this = this;
        var data, downloadQueryParam;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return post(this.fetch, "".concat(this.url, "/object/sign/").concat(this.bucketId), {
                expiresIn: expiresIn,
                paths: paths
              }, {
                headers: this.headers
              });
            case 3:
              data = _context9.sent;
              downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? "&download=".concat(options.download === true ? '' : options.download) : '';
              return _context9.abrupt("return", {
                data: data.map(function (datum) {
                  return Object.assign(Object.assign({}, datum), {
                    signedUrl: datum.signedURL ? encodeURI("".concat(_this.url).concat(datum.signedURL).concat(downloadQueryParam)) : null
                  });
                }),
                error: null
              });
            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](0);
              if (!isStorageError(_context9.t0)) {
                _context9.next = 12;
                break;
              }
              return _context9.abrupt("return", {
                data: null,
                error: _context9.t0
              });
            case 12:
              throw _context9.t0;
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[0, 8]]);
      }));
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */
  }, {
    key: "download",
    value: function download(path, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var wantsTransformation, renderPath, transformationQuery, queryString, _path, res, data;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
              renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
              transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
              queryString = transformationQuery ? "?".concat(transformationQuery) : '';
              _context10.prev = 4;
              _path = this._getFinalPath(path);
              _context10.next = 8;
              return get(this.fetch, "".concat(this.url, "/").concat(renderPath, "/").concat(_path).concat(queryString), {
                headers: this.headers,
                noResolveJson: true
              });
            case 8:
              res = _context10.sent;
              _context10.next = 11;
              return res.blob();
            case 11:
              data = _context10.sent;
              return _context10.abrupt("return", {
                data: data,
                error: null
              });
            case 15:
              _context10.prev = 15;
              _context10.t0 = _context10["catch"](4);
              if (!isStorageError(_context10.t0)) {
                _context10.next = 19;
                break;
              }
              return _context10.abrupt("return", {
                data: null,
                error: _context10.t0
              });
            case 19:
              throw _context10.t0;
            case 20:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[4, 15]]);
      }));
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */
  }, {
    key: "getPublicUrl",
    value: function getPublicUrl(path, options) {
      var _path = this._getFinalPath(path);
      var _queryString = [];
      var downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? "download=".concat(options.download === true ? '' : options.download) : '';
      if (downloadQueryParam !== '') {
        _queryString.push(downloadQueryParam);
      }
      var wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
      var renderPath = wantsTransformation ? 'render/image' : 'object';
      var transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
      if (transformationQuery !== '') {
        _queryString.push(transformationQuery);
      }
      var queryString = _queryString.join('&');
      if (queryString !== '') {
        queryString = "?".concat(queryString);
      }
      return {
        data: {
          publicUrl: encodeURI("".concat(this.url, "/").concat(renderPath, "/public/").concat(_path).concat(queryString))
        }
      };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */
  }, {
    key: "remove",
    value: function remove(paths) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var data;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return _remove(this.fetch, "".concat(this.url, "/object/").concat(this.bucketId), {
                prefixes: paths
              }, {
                headers: this.headers
              });
            case 3:
              data = _context11.sent;
              return _context11.abrupt("return", {
                data: data,
                error: null
              });
            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](0);
              if (!isStorageError(_context11.t0)) {
                _context11.next = 11;
                break;
              }
              return _context11.abrupt("return", {
                data: null,
                error: _context11.t0
              });
            case 11:
              throw _context11.t0;
            case 12:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[0, 7]]);
      }));
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */
    // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */
    // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */
  }, {
    key: "list",
    value: function list(path, options, parameters) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var body, data;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              body = Object.assign(Object.assign(Object.assign({}, DEFAULT_SEARCH_OPTIONS), options), {
                prefix: path || ''
              });
              _context12.next = 4;
              return post(this.fetch, "".concat(this.url, "/object/list/").concat(this.bucketId), body, {
                headers: this.headers
              }, parameters);
            case 4:
              data = _context12.sent;
              return _context12.abrupt("return", {
                data: data,
                error: null
              });
            case 8:
              _context12.prev = 8;
              _context12.t0 = _context12["catch"](0);
              if (!isStorageError(_context12.t0)) {
                _context12.next = 12;
                break;
              }
              return _context12.abrupt("return", {
                data: null,
                error: _context12.t0
              });
            case 12:
              throw _context12.t0;
            case 13:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[0, 8]]);
      }));
    }
  }, {
    key: "_getFinalPath",
    value: function _getFinalPath(path) {
      return "".concat(this.bucketId, "/").concat(path);
    }
  }, {
    key: "_removeEmptyFolders",
    value: function _removeEmptyFolders(path) {
      return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
  }, {
    key: "transformOptsToQueryString",
    value: function transformOptsToQueryString(transform) {
      var params = [];
      if (transform.width) {
        params.push("width=".concat(transform.width));
      }
      if (transform.height) {
        params.push("height=".concat(transform.height));
      }
      if (transform.resize) {
        params.push("resize=".concat(transform.resize));
      }
      if (transform.format) {
        params.push("format=".concat(transform.format));
      }
      if (transform.quality) {
        params.push("quality=".concat(transform.quality));
      }
      return params.join('&');
    }
  }]);
  return StorageFileApi;
}();
export { StorageFileApi as default };